/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Front_Keen_Giraffe_SavorInputs */

const fr_front_keen_giraffe_savor = /** @type {(inputs: Front_Keen_Giraffe_SavorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

/**

* @param {Front_Keen_Giraffe_SavorInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const front_keen_giraffe_savor = /** @type {((inputs?: Front_Keen_Giraffe_SavorInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Front_Keen_Giraffe_SavorInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_front_keen_giraffe_savor(inputs)
});